import {FC} from "react";
import ISvg from "../../interfaces/ISvg";

interface IChevron extends ISvg {
    color?: string
}

const Chevron:FC<IChevron> = ({className, color = "fill-disabled-400"}) => {
    return <svg className={className} width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" className={color} clipRule="evenodd" d="M15.63 8.64054C16.1233 8.16126 16.1233 7.38419 15.63 6.90491L8.89319 0.35946C8.39989 -0.11982 7.60011 -0.11982 7.10681 0.35946L0.36997 6.90491C-0.123323 7.38419 -0.123323 8.16126 0.36997 8.64054C0.863264 9.11982 1.66305 9.11982 2.15635 8.64054L8 2.9629L13.8437 8.64054C14.3369 9.11982 15.1367 9.11982 15.63 8.64054Z" />
    </svg>
}

export default Chevron;